import React from 'react'
import Loader from '@amzn/meridian/loader'
import Text from '@amzn/meridian/text'
import Column from '@amzn/meridian/column'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { LOADING_STORES } from '../constants'

/**
 * LoadingIndicator Component
 *
 * Displays a loading spinner and message while stores are being fetched.
 */
export const LoadingIndicator: React.FC = () => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
      <Column alignmentHorizontal="center" spacingInset="600 none">
        <Loader />
        <Text>{t(bundle, LOADING_STORES)}</Text>
      </Column>
    )
}
